import { ParamError } from "@/views/zhiji/js/common/errors.js";
import { quesSaveType } from "@/views/zhiji/js/common/constants.js";
import widgetManager from "./widgets/widgetManager.js";

import i18n from "@/i18n";

// 转换成后台需要的参数结构
export function checkValidate(state) {
    let answerGather = { hasStatus: false, noChannelAnswerName: false };
    state.answers.forEach(({ props: { answerStatus, effectChannel: { channel } }, updateState, name, contents }) => {
        if (updateState !== "delete") {
            if (answerStatus === "1" && !answerGather.hasStatus) {
                answerGather.hasStatus = true;
            }
            if (contents.length === 0 || (contents.length === 1 && contents[0].updateState === "delete")) {
                answerGather.emptyContent = true;
            }
        }
        if (channel.length === 0 && !answerGather.noChannelAnswerName) {
            answerGather.noChannelAnswerName = name;
        }
    })

    const info = { ...state.questionInfo, answerGather };

    const needCheckParam = quesSaveType.DRAFT != state.saveType;

    checkQuestionParam(info); // 校验必填字段，草稿状态和上线都需要校验

    needCheckParam && checkAnswer(state, needCheckParam);
}

// 意图实体答案转换成后台需要的参数结构
export function checkAnswerValidate(state) {
    const needCheckParam = quesSaveType.DRAFT != state.saveType;

    needCheckParam && checkAnswer(state, needCheckParam);
}

function checkQuestionParam({ sceneClassId, standQuestion, optionTip, answerGather: { noChannelAnswerName, hasStatus, emptyContent } }) {
    // 校验标准问法是否包含特殊字符
    // const specialChars = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g;
    // const standQuestionMatch = standQuestion.match(specialChars) ? standQuestion.match(specialChars).join(",") : "";

    if (sceneClassId == "def" || sceneClassId == "") {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.sceneClassifyTip"));
    } else if (!standQuestion) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.standQuesTip"));
    } else if (!optionTip) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.shortbarDefTip"));
    } else if (!hasStatus) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.answerEnabledOne"));
    } else if (noChannelAnswerName) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.answerChannelOne"));
    } else if (emptyContent) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.emptyAnswerContent"));
    }
}

function checkAnswer(state, needCheckParam) {
    let ret = [];
    let answerCount = 0; // 展示的问题数量

    state.answers.forEach(function(answer) {
        if (answer.updateState != "") {
            checkProps(answer.props, needCheckParam);
            checkContent(answer.contents, needCheckParam);
            checkOption(answer.options, needCheckParam);
        }

        if (answer.updateState != "delete") {
            answerCount++;
        }
    });

    if (needCheckParam && answerCount === 0) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.editQuesAns"));
    }

    return ret;
}

function checkProps(props, needCheckParam) {
    let gameId = window.localStorage.getItem("gameId");
    let users = props.effectUser;
    let channels = props.effectChannel.channel;
    // 特殊处理，只有在内容助手下需校验
    if (gameId === "80002") {
        let noEffectUser = users.indexOf("178") === -1 && users.indexOf("179") === -1;

        let noEffectChannel = channels.indexOf("mobile") === -1 && channels.indexOf("lite") === -1;

        if (noEffectUser && needCheckParam) {
            throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.noEffectModel"));
        }

        if (noEffectChannel && needCheckParam) {
            throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.noEffectChannel"));
        }
    }
}

function checkContent(contents, needCheckParam) {
    let contentCount = 0; // 问题的回答数量

    contents.forEach(function(content) {
        const widgetHandler = widgetManager.clientMap[content.wtType];

        if (content.updateState != "" && content.updateState != "delete" && needCheckParam && widgetHandler) {
            widgetHandler.checkContent.call(null, content);
        }

        if (content.updateState != "delete") {
            contentCount++;
        }
    });

    if (needCheckParam && contentCount === 0) {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.noAnswerDetail"));
    }
}

function checkOption(options, needCheckParam) {
    let ret = [];

    options.forEach(function(option) {
        if (option.updateState != "" && option.updateState != "delete") {
            needCheckParam && checkOptionParam(option); // 校验快捷栏
        }
    });

    return ret;
}

function checkOptionParam(option) {
    if (!option.name && option.itemType !== "labor") {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.shortbarName"));
    } else if (!option.questionId && option.itemType !== "labor") {
        throw new ParamError(i18n.t("zhiji.knowlege.quesEditModal.shortbarLinkQues"));
    } else if (option.itemType === "labor" && !option.formId) {
        throw new ParamError(i18n.t("zhiji.answer.laborSearchLabel"));
    }
}
